import { Loader2 } from "lucide-react";
import { Button, Modal, ModalBody, ModalFooter } from "../ui";

type Props = {
  open: boolean;
  onClose: () => void;
  title: string;
  description: string;
  confirmLabel: string;
  isPending: boolean;
  variant: "danger" | "warning";
  icon: React.ReactNode;
  onConfirm: () => void;
};

export function ConfirmModal({
  open,
  onClose,
  title,
  description,
  confirmLabel,
  isPending,
  variant,
  icon,
  onConfirm,
}: Props) {
  const colorClass =
    variant === "danger"
      ? "!bg-error-500 hover:!bg-error-600"
      : "!bg-yellow-500 hover:!bg-yellow-600 !text-surface-900";
  const bgClass =
    variant === "danger"
      ? "bg-error-500/10 border-error-500/20"
      : "bg-yellow-500/10 border-yellow-500/20";

  return (
    <Modal open={open} onClose={onClose} className="!max-w-sm">
      <div className="px-6 pt-6 pb-1 flex items-center gap-3">
        <div className={`flex items-center justify-center w-10 h-10 rounded-xl border ${bgClass}`}>
          {icon}
        </div>
        <div>
          <h2 className="text-xl font-bold text-white">{title}</h2>
        </div>
      </div>
      <ModalBody>
        <p className="text-sm text-surface-300">{description}</p>
      </ModalBody>
      <ModalFooter>
        <Button variant="ghost" onClick={onClose} disabled={isPending}>
          Cancel
        </Button>
        <Button
          variant="primary"
          className={colorClass}
          disabled={isPending}
          leftIcon={isPending ? <Loader2 className="size-4 animate-spin" /> : undefined}
          onClick={onConfirm}
        >
          {isPending ? "Processing..." : confirmLabel}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
